document.addEventListener("DOMContentLoaded", function () {
    const timelineWrap = document.querySelector(".timeline-wrap");
    const items = document.querySelectorAll(".timeline-wrap-item");
    const bgImageitems = document.querySelectorAll(".background-image-items");
    let currentIndex = 0;
    let interval;

    function isMobileView() {
        return window.innerWidth <= 768;
    }

    function scrollToActiveItem() {
        if (isMobileView()) {
            const activeItem = items[currentIndex];
            if (activeItem) {
                activeItem.scrollIntoView({
                    behavior: "smooth",
                    block: "nearest",
                    inline: "center"
                });
            }
        }
    }

    function shouldScroll() {
        const wrapRect = timelineWrap.getBoundingClientRect();
        const lastVisibleItem = [...items].reverse().find(item => {
            const itemRect = item.getBoundingClientRect();
            return itemRect.right <= wrapRect.right;
        });
        return items[currentIndex] === lastVisibleItem;
    }

    function activateNext() {
        items.forEach(item => item.classList.remove("active"));
        bgImageitems.forEach(bgItem => bgItem.classList.remove("active"));
        items[currentIndex].classList.add("active");
        bgImageitems[currentIndex].classList.add("active");

        scrollToActiveItem();

        if (currentIndex === items.length - 1) {
            setTimeout(() => {
                timelineWrap.scrollTo({ left: 0, behavior: "smooth" });
                currentIndex = 0;
                items.forEach(item => item.classList.remove("active"));
                bgImageitems.forEach(bgItem => bgItem.classList.remove("active"));
                items[currentIndex].classList.add("active");
                bgImageitems[currentIndex].classList.add("active");
                scrollToActiveItem();
            }, 1000);
        } else {
            if (shouldScroll()) {
                items[currentIndex].scrollIntoView({
                    behavior: "smooth",
                    block: "nearest",
                    inline: "start"
                });
            }
            currentIndex = (currentIndex + 1) % items.length;
        }
    }

    function startAnimation() {
        stopAnimation();
        interval = setInterval(activateNext, 5000);
    }

    function stopAnimation() {
        clearInterval(interval);
    }

    function setEqualHeight() {
        let maxHeight = 0;
        items.forEach(item => {
            const content = item.querySelector(".timeline-wrap-item-content .content-box");
            if (content) {
                maxHeight = Math.max(maxHeight, content.offsetHeight);
            }
        });
        items.forEach(item => {
            item.style.height = `${maxHeight + 100}px`;
        });
    }

    function disableScrollingIfNeeded() {
        const containerWidth = timelineWrap.offsetWidth;
        const visibleItems = Math.floor(containerWidth / items[0].offsetWidth);
        if ((window.innerWidth >= 1200 && items.length < 7) ||
            (window.innerWidth >= 768 && window.innerWidth < 1200 && items.length < 2)) {
            timelineWrap.style.overflowX = "hidden";
        } else {
            timelineWrap.style.overflowX = "scroll";
        }
    }

    const activeItem = document.querySelector(".timeline-wrap-item.active");
    currentIndex = activeItem ? [...items].indexOf(activeItem) : 0;

    setEqualHeight();
    startAnimation();
    disableScrollingIfNeeded();

    items.forEach(item => {
        item.addEventListener("mouseenter", stopAnimation);
        item.addEventListener("mouseleave", startAnimation);
    });

    document.querySelectorAll(".timeline-wrap-item__year").forEach((yearElement, index) => {
        yearElement.addEventListener("click", function () {
            stopAnimation();
            items.forEach(item => item.classList.remove("active"));
            bgImageitems.forEach(bgItem => bgItem.classList.remove("active"));

            currentIndex = index;
            items[currentIndex].classList.add("active");
            bgImageitems[currentIndex].classList.add("active");

            scrollToActiveItem();

            setTimeout(startAnimation, 2000);
        });
    });

    window.addEventListener("resize", () => {
        setEqualHeight();
        disableScrollingIfNeeded();
        scrollToActiveItem();
    });

    timelineWrap.style.scrollBehavior = "smooth";
    timelineWrap.style.scrollbarWidth = "none";
    timelineWrap.style.msOverflowStyle = "none";
});